import Tooltip from "@/components/design-system/tooltip";
import styles from "./unknownHeavyShippingCharge.module.scss";

function UnknownHeavyShippingCharge({ vendorOption, heavyShippingClassName }: UnknownHeavyShippingChargeProps) {
  heavyShippingClassName = heavyShippingClassName ? heavyShippingClassName : "";

  const heavyShippingPopoverMessage =
    "Net32 will contact you with the additional shipping surcharge after your order is placed.";

  return (
    <span className={styles.UnknownHeavyShippingCharge}>
      <Tooltip
        tailPlacement="above"
        id={`unknown-heavy-shipping-${vendorOption.vendorProductId}`}
        content={heavyShippingPopoverMessage}
      >
        <button type="button" className={`${heavyShippingClassName} ${styles.message}`}>
          *Heavy shipping surcharge will apply
        </button>
      </Tooltip>
    </span>
  );
}

type UnknownHeavyShippingChargeProps = {
  vendorOption: VendorOptionState;
  heavyShippingClassName?: string;
};

export default UnknownHeavyShippingCharge;
